import React__default, { createElement } from 'react';
import styled, { css, ThemeProvider } from 'styled-components';
import { token, spaceMixin, TextButton, Spacer, mediaMixin, ThemeConstellation, Paragraph, Heading, Divider } from '@zillow/constellation';

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _templateObject, _templateObject2, _templateObject3;
var StyleWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    background: ", ";\n    border-radius: 8px;\n    display: flex;\n    flex-direction: row;\n    text-align: left;\n    align-items: center;\n    margin-bottom: ", ";\n    height: 84px;\n    font-family: 'Open Sans', Tahoma, Geneva, sans-serif;\n"])), token('colors.coolGray100'), spaceMixin('xs'));
var StyledTextButton = styled(TextButton)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    text-align: left;\n    color: ", ";\n    text-decoration: none;\n    font-weight: 700;\n\n    :hover {\n        text-decoration: underline;\n    }\n"])), token('colors.blue500'));
var StyledIconSpacer = styled(Spacer)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    margin: ", ";\n    ", "\n"])), spaceMixin('md'), mediaMixin('lg', css(["margin-left:", ";margin-right:", ";"], spaceMixin('xl'), spaceMixin('xl'))));

var OptionsCard = function OptionsCard(_ref) {
  var Icon = _ref.Icon,
      onClick = _ref.onClick,
      title = _ref.title,
      urlText = _ref.urlText,
      url = _ref.url;
  return /*#__PURE__*/React__default.createElement(ThemeProvider, {
    theme: ThemeConstellation
  }, /*#__PURE__*/React__default.createElement(StyleWrapper, null, /*#__PURE__*/React__default.createElement(StyledIconSpacer, null, /*#__PURE__*/React__default.createElement(Icon, null)), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Paragraph, null, title), /*#__PURE__*/React__default.createElement(StyledTextButton, {
    as: "a",
    href: url,
    onClick: onClick
  }, urlText))));
};

var _templateObject$1, _templateObject2$1, _templateObject3$1;

var Handshake = function Handshake(props) {
  return /*#__PURE__*/createElement("svg", props, /*#__PURE__*/createElement("path", {
    d: "M35.243 18.708l-3.655-3.656c-.01-.009-.02-.015-.029-.024-.009-.009-.015-.02-.024-.029l-6.29-6.291a3.964 3.964 0 0 0-5.59 0l-.86.861-4.985-4.983a2 2 0 0 0-2.827 0l-5.4 5.4a2 2 0 0 0 0 2.827l4.991 4.987a3.96 3.96 0 0 0 .048 5.531l6.291 6.291c.01.01.02.015.03.024.008.01.014.02.023.03l3.655 3.654a2.585 2.585 0 0 0 3.656-3.655 2.585 2.585 0 1 0 3.655-3.656 2.585 2.585 0 0 0 3.656-3.655 2.584 2.584 0 1 0 3.655-3.655v-.001z",
    fill: "#A6E5FF"
  }), /*#__PURE__*/createElement("path", {
    d: "M17.275 35.976l-.1-.1a.036.036 0 0 0 .023.012h.012c0 .011 0 .011.011.022l.023.023c.008.009.02.032.031.043zM10.856 18.31l-2.363 2.363v-.01l2.363-2.353zM22.82 28.444a2.49 2.49 0 0 1-.183.386h-.01c.07-.125.135-.254.192-.386zM23.705 29.546v.011a2.454 2.454 0 0 0-.25-.227c.088.066.172.138.25.216z",
    fill: "#006AFF"
  }), /*#__PURE__*/createElement("path", {
    d: "M17.2 35.886a.036.036 0 0 1-.023-.012 3.004 3.004 0 0 1-.227-.3c.074.11.158.215.25.312zM17.218 35.908l-.023-.022h.012c0 .014 0 .014.011.022z",
    fill: "#006AFF"
  }), /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 13.658a4.53 4.53 0 0 1-1.332 3.208l-2.62 2.62a4.541 4.541 0 0 1-1.726 1.074l2.131 2.137a3.858 3.858 0 0 1 0 5.42 3.756 3.756 0 0 1-2.505 1.111 3.82 3.82 0 0 1-1.112 2.506 3.706 3.706 0 0 1-2.5 1.112 3.813 3.813 0 0 1-3.617 3.617 3.7 3.7 0 0 1-1.112 2.505 3.834 3.834 0 0 1-5.419 0l-3.425-3.426-.077-.076-.02-.026c-.006-.01-.012-.019-.018-.025l-.026-.026c-.007-.007-.01-.01-.012-.014a.021.021 0 0 1 0-.008v-.004h-.013a2.5 2.5 0 0 1-.282-.345c-.228-.3-.4-.639-.51-1a2.721 2.721 0 0 1-.14-.536 2.43 2.43 0 0 1-.078-.524 3.787 3.787 0 0 1-3.617-3.618 3.811 3.811 0 0 1-3.617-3.617 3.138 3.138 0 0 1-.358-.038 3.731 3.731 0 0 1-2.147-1.06 3.832 3.832 0 0 1-.729-4.385 4.525 4.525 0 0 1 .205-6.173l5.33-5.33a4.529 4.529 0 0 1 6.415 0l.537.537c.205-.383.468-.732.78-1.035l1.8-1.815a5.156 5.156 0 0 1 7.234 0l.895.907.41-.409a4.553 4.553 0 0 1 6.415 0l3.528 3.528A4.529 4.529 0 0 1 40 13.658zM8.56 23.18c.34.002.667-.131.908-.37l.892-.895 2.71-2.723a1.273 1.273 0 0 0 0-1.8 1.28 1.28 0 0 0-1.8 0l-2.71 2.71-.907.907a1.272 1.272 0 0 0 .907 2.171zm3.612 3.62a1.233 1.233 0 0 1-.907-.37 1.272 1.272 0 0 1 0-1.8l3.617-3.618 1.8-1.815a1.3 1.3 0 0 1 1.815 0 1.3 1.3 0 0 1 0 1.815l-1.71 1.708a.618.618 0 0 0-.1.09l-3.618 3.616c-.235.243-.56.378-.897.374zm2.723 3.222c.49.494 1.286.505 1.79.024l1.815-1.822 1.8-1.8a1.272 1.272 0 0 0 0-1.8 1.251 1.251 0 0 0-1.8 0l-3.616 3.608c-.484.5-.48 1.296.01 1.79zm4.5 4.012a1.278 1.278 0 0 1-.896-2.185l1.8-1.8c.24-.24.568-.374.908-.37.336-.004.66.13.894.37a1.252 1.252 0 0 1 0 1.8l-1.8 1.815a1.29 1.29 0 0 1-.907.367v.003zm2.59 3.13a1.314 1.314 0 0 0 1.815 0c.501-.5.505-1.312.007-1.816a1.245 1.245 0 0 1-.345-1.087 1.15 1.15 0 0 1 .026-.097c.01-.031.019-.063.025-.094H23.5l-1.4 1.393a3.794 3.794 0 0 1-1.06.741l.945.96zm12.657-12.655a1.275 1.275 0 0 1-1.8 1.8 1.275 1.275 0 1 0-1.8 1.8 1.311 1.311 0 0 1 0 1.814c-.502.5-1.313.5-1.815 0a1.275 1.275 0 0 0-1.8 1.8 1.283 1.283 0 1 1-1.815 1.815 1.255 1.255 0 0 0-1.355-.282c.13-.166.242-.346.333-.536a5.04 5.04 0 0 0 .332-.882c.028-.1.049-.203.064-.307a3.787 3.787 0 0 0-1.061-3.298 2.62 2.62 0 0 0-.28-.255 3.137 3.137 0 0 0-.55-.37 1.998 1.998 0 0 0-.37-.193H22.7c.08-.14.153-.285.217-.434.069-.153.124-.31.166-.473.045-.16.079-.322.1-.486a3.51 3.51 0 0 0 0-1.022 3.17 3.17 0 0 0-.128-.6 3.261 3.261 0 0 0-.28-.69 6.938 6.938 0 0 0-.193-.32 4.303 4.303 0 0 0-.486-.588 3.617 3.617 0 0 0-1.2-.8 3.811 3.811 0 0 0-5.215-5.215c-.024-.047-.048-.098-.072-.15a3.862 3.862 0 0 0-.481-.783c-.044-.044-.086-.09-.127-.134-.042-.045-.083-.09-.128-.134a3.712 3.712 0 0 0-1.598-.959 3.592 3.592 0 0 0-.358-.089 3.688 3.688 0 0 0-.754-.077 3.773 3.773 0 0 0-2.709 1.125L6.8 18.246v-.012a1.98 1.98 0 0 1 .32-2.365l5.33-5.33a1.984 1.984 0 0 1 2.811 0l1.653 1.661a4.985 4.985 0 0 0 1.431 3.223c.01.012.021.027.04.036a5.032 5.032 0 0 0 6.2.78 4.81 4.81 0 0 0 1.008-.78l9.05 9.05zm-3.314-6.94a2.123 2.123 0 0 0 2.914.115l2.623-2.618a2.006 2.006 0 0 0 0-2.812L33.338 8.74a1.968 1.968 0 0 0-2.8 0l-.818.8a1.967 1.967 0 0 1-2.8 0l-1.317-1.3a2.567 2.567 0 0 0-.843-.563 2.5 2.5 0 0 0-1.917 0c-.32.13-.611.32-.857.563l-1.8 1.8a2.584 2.584 0 0 0 0 3.617c.081.078.171.147.268.205a2.4 2.4 0 0 0 1.534.536c.203.008.406-.018.6-.076a2.394 2.394 0 0 0 1.214-.665l1.8-1.8 5.726 5.713z",
    fill: "#0D4599"
  }), /*#__PURE__*/createElement("path", {
    d: "M38.482 29.165v.018A4.152 4.152 0 0 1 35.55 32.1h-.018a.227.227 0 0 0 0 .442h.018a4.152 4.152 0 0 1 2.933 2.914v.018a.2.2 0 0 0 .393 0v-.018a4.149 4.149 0 0 1 2.932-2.914h.018a.227.227 0 0 0 0-.442h-.018a4.149 4.149 0 0 1-2.932-2.914v-.018a.2.2 0 0 0-.393 0v-.003zM3.975 29.1v.01a2.39 2.39 0 0 1-1.688 1.678h-.01a.13.13 0 0 0 0 .254h.01a2.39 2.39 0 0 1 1.688 1.678v.01a.115.115 0 0 0 .226 0v-.01a2.388 2.388 0 0 1 1.688-1.678H5.9a.13.13 0 0 0 0-.254h-.01a2.388 2.388 0 0 1-1.69-1.683V29.1a.115.115 0 0 0-.132-.1.113.113 0 0 0-.093.1z",
    fill: "#F2A619"
  }));
};

Handshake.defaultProps = {
  width: "44",
  height: "44",
  viewBox: "0 0 44 44",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var Painter = function Painter(props) {
  return /*#__PURE__*/createElement("svg", props, /*#__PURE__*/createElement("path", {
    d: "M41 9a.78.78 0 0 0-.084.017c-.029 0-.054-.017-.084-.017H13.168c-.03 0-.055.015-.084.017A.78.78 0 0 0 13 9a1 1 0 0 0-1 1v15a1 1 0 0 0 1 1h20a1.007 1.007 0 0 0 1-1v-2a1 1 0 1 1 2 0v4a1 1 0 1 0 2 0v-4a1 1 0 1 1 2 0v6a1 1 0 1 0 2 0V10a1 1 0 0 0-1-1z",
    fill: "#A6E5FF"
  }), /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 34.343l.861-7.354a1.294 1.294 0 0 1 1.286-1.132h2.134a1.293 1.293 0 0 1 1.286 1.132l.862 7.354a3.217 3.217 0 0 1-6.429 0zm4.373-1.263c-.2-.481-.672-.794-1.193-.791v-.003a1.288 1.288 0 0 0-.488 2.477 1.286 1.286 0 0 0 1.68-1.683z",
    fill: "#F2A619"
  }), /*#__PURE__*/createElement("path", {
    d: "M23.18 34.857a1.286 1.286 0 1 0 .012-2.572 1.286 1.286 0 0 0-.012 2.572z",
    fill: "#0D4599"
  }), /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.857 4H12.286a5.141 5.141 0 0 0-5.143 5.143H5.857A3.869 3.869 0 0 0 2 13v5.143A3.869 3.869 0 0 0 5.857 22h14.786a1.29 1.29 0 0 1 1.286 1.286v.025a3.838 3.838 0 0 0-3.613 3.382l-.887 7.521a5.786 5.786 0 1 0 11.571 0l-.887-7.521a3.84 3.84 0 0 0-3.613-3.382v-.025a3.868 3.868 0 0 0-3.857-3.857H5.857a1.29 1.29 0 0 1-1.286-1.286V13a1.29 1.29 0 0 1 1.286-1.286h1.286a5.14 5.14 0 0 0 5.143 5.143h20.571A5.14 5.14 0 0 0 38 11.714V9.143A5.14 5.14 0 0 0 32.857 4zm-7.29 22.989l.862 7.354a3.217 3.217 0 0 1-6.429 0l.861-7.354a1.294 1.294 0 0 1 1.286-1.132h2.134a1.293 1.293 0 0 1 1.286 1.132zm7.29-12.703a2.58 2.58 0 0 0 2.572-2.572V9.143a2.58 2.58 0 0 0-2.572-2.572H12.286a2.58 2.58 0 0 0-2.572 2.572v2.571a2.579 2.579 0 0 0 2.572 2.572h20.571z",
    fill: "#0D4599"
  }));
};

Painter.defaultProps = {
  width: "44",
  height: "44",
  viewBox: "0 0 44 44",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var ForSale = function ForSale(props) {
  return /*#__PURE__*/createElement("svg", props, /*#__PURE__*/createElement("path", {
    d: "M30 2c-6.075 0-11 4.925-11 11v24a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3V13c0-6.075-4.925-11-11-11z",
    fill: "#A6E5FF"
  }), /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.8 11.153H10.766V7.2a1.289 1.289 0 0 0-2.572 0v3.953H4.2a1.289 1.289 0 0 0 0 2.57h3.994V40.8a1.289 1.289 0 0 0 2.572 0V13.724h5.143V16.3a2.58 2.58 0 0 0-2.572 2.572v11.566a2.58 2.58 0 0 0 2.572 2.572h18a2.579 2.579 0 0 0 2.57-2.572V18.867a2.579 2.579 0 0 0-2.57-2.567v-2.576h3.89a1.289 1.289 0 0 0 0-2.571zm-3.891 19.285h-18V18.867h18v11.57zM18.479 16.3h12.858v-2.576H18.48V16.3z",
    fill: "#0D4599"
  }), /*#__PURE__*/createElement("path", {
    d: "M25.992 22.14l-2.327 1.85-.463-.474a1.291 1.291 0 0 0-1.826 1.825l1.286 1.286c.244.238.572.372.913.373.291.003.575-.097.8-.283l3.214-2.571a1.281 1.281 0 1 0-1.594-2.006h-.003z",
    fill: "#F2A619"
  }));
};

ForSale.defaultProps = {
  width: "44",
  height: "44",
  viewBox: "0 0 44 44",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var StyleWrapper$1 = styled.div(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n    .cards {\n        margin-top: ", ";\n    }\n\n    .cards:first-child {\n        margin-top: 0;\n    }\n"])), spaceMixin('sm'));
var StyledHeading = styled(Heading)(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral(["\n    font-family: serif;\n    font-weight: bold;\n    text-align: center;\n    margin-top: ", ";\n    margin-bottom: ", ";\n"])), spaceMixin('md'), spaceMixin('md'));
var BlueDivider = styled(Divider)(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteral(["\n    background-color: ", ";\n"])), function (props) {
  return props.dividerColor;
});

var OtherWaysToSell = function OtherWaysToSell(_ref) {
  var dividerColor = _ref.dividerColor,
      header = _ref.header,
      onClickAgentFinder = _ref.onClickAgentFinder,
      onClickFsbo = _ref.onClickFsbo,
      onClickSellerGuide = _ref.onClickSellerGuide;
  return /*#__PURE__*/createElement(ThemeProvider, {
    theme: ThemeConstellation
  }, /*#__PURE__*/createElement(StyleWrapper$1, {
    className: "other-ways-to-sell"
  }, /*#__PURE__*/createElement(BlueDivider, {
    dividerColor: dividerColor,
    appearance: "emphasized",
    length: "fixed",
    marginX: "auto",
    marginY: "md"
  }), /*#__PURE__*/createElement(StyledHeading, {
    level: "5"
  }, header), /*#__PURE__*/createElement(OptionsCard, {
    className: "cards",
    Icon: Handshake,
    onClick: onClickAgentFinder,
    url: "/agent-finder/",
    title: "Sell with a trusted agent",
    urlText: "View agent profiles"
  }), /*#__PURE__*/createElement(OptionsCard, {
    className: "cards",
    Icon: ForSale,
    onClick: onClickFsbo,
    url: "/for-sale-by-owner/",
    title: "Sell it yourself",
    urlText: "Create a listing"
  }), /*#__PURE__*/createElement(OptionsCard, {
    className: "cards",
    Icon: Painter,
    onClick: onClickSellerGuide,
    url: "/sellers-guide/",
    title: "Learn about the selling process",
    urlText: "Go to Sellers Guide"
  })));
};

OtherWaysToSell.defaultProps = {
  dividerColor: token('colors.blue400'),
  header: 'Other ways we can help you sell',
  onClickAgentFinder: function onClickAgentFinder() {},
  onClickFsbo: function onClickFsbo() {},
  onClickSellerGuide: function onClickSellerGuide() {}
};

export default OtherWaysToSell;
